const shipments = [
  {
    id: 1,
    orderId: "#TBT1",
    shipment_no: "TBSN15412120001",
    customer_name: "Vinod Kumar",
    supplier: "iTest Factory",
    location: "India",
    order_date: "23 Dec, 2022",
    arrival_date: "15 Jan, 2023",
    status: "Delivered",
  },
  {
    id: 2,
    orderId: "#TBT2",
    shipment_no: "TBSN15412124512",
    customer_name: "Parth",
    supplier: "Themesbrand",
    location: "India",
    order_date: "06 Jan, 2023",
    arrival_date: "19 Jan, 2023",
    status: "Pending",
  },
  {
    id: 3,
    orderId: "#TBT3",
    shipment_no: "TBSN15412102154",
    customer_name: "Manish",
    supplier: "Scott Wilson",
    location: "India",
    order_date: "12 Oct, 2022",
    arrival_date: "01 Nov, 2022",
    status: "Delivered",
  },
  {
    id: 4,
    orderId: "#TBT4",
    shipment_no: "TBSN15414512307",
    customer_name: "Mangesh",
    supplier: "Scott Fry",
    location: "India",
    order_date: "03 Jan, 2023",
    arrival_date: "20 Jan, 2023",
    status: "Shipping",
  },
  {
    id: 5,
    orderId: "#TBT5",
    shipment_no: "TBSN15414516748",
    customer_name: "Harsh",
    supplier: "Farhan Stein",
    location: "India",
    order_date: "16 Jan, 2023",
    arrival_date: "29 Feb, 2023",
    status: "Pickups",
  },
  {
    id: 6,
    orderId: "#TBT6",
    shipment_no: "TBSN15414521032",
    customer_name: "Siju",
    supplier: "Zibra Cube",
    location: "India",
    order_date: "02 Feb, 2023",
    arrival_date: "24 Mar, 2023",
    status: "Shipping",
  },
];

export { shipments };
